module.exports = __webpack_public_path__ + "e7858765e7d25bba626ad1ec7a69e705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-isi.png
// module id = 2095
// module chunks = 4